var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.94728 10.1695C7.4202 9.64337 7.09937 8.92837 7.09937 8.12629C7.09937 6.51937 8.3937 5.22412 9.9997 5.22412C10.7944 5.22412 11.5259 5.54587 12.0439 6.07204",
    stroke: "#0F0F0F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8461 8.64062C12.6334 9.82312 11.7021 10.7563 10.5205 10.9708",
    stroke: "#0F0F0F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.10009 13.0162C3.64534 11.8741 2.41334 10.2057 1.52051 8.12581C2.42251 6.03673 3.66276 4.35923 5.12667 3.2079C6.58142 2.05656 8.25984 1.4314 9.99967 1.4314C11.7496 1.4314 13.4271 2.06573 14.891 3.22531",
    stroke: "#0F0F0F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.827 5.24158C17.4577 6.07941 18.0123 7.04649 18.4789 8.12541C16.6758 12.3027 13.4895 14.8189 9.99971 14.8189C9.20863 14.8189 8.42854 14.6906 7.67871 14.4403",
    stroke: "#0F0F0F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2298 0.895447L2.77026 15.3549",
    stroke: "#0F0F0F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHide);
export default __webpack_public_path__ + "static/media/Hide.19f45547f93514a43bd254a42c030d75.svg";
export { ForwardRef as ReactComponent };